import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getFacilityProvider } from 'api/Admin/Practice/Providers';

export const useFacilityProvider = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(
    ['facility-provider', ...dependencies],
    () => getFacilityProvider(navigate, params),
    {
      enabled: !!params.practiceId,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
      ...options
    }
  );
};
